export const parseIdArray = (
  items?: (string | null)[] | null,
): number[] | undefined => {
  if (!items?.length) return undefined;

  const parsed = items
    .filter((id): id is string => id !== null && id !== "")
    .map(Number)
    .filter((id) => !isNaN(id) && id > 0);

  return parsed.length > 0 ? parsed : undefined;
};

export const parseBoolean = (value?: string | null): boolean | undefined => {
  if (value === undefined || value === null) return undefined;
  return value === "true";
};

export const parseString = (value?: string | null): string | undefined => {
  if (value === undefined || value === null || value === "") return undefined;
  return value;
};

export const parseEnumArray = <T extends string>(
  items?: (string | null)[] | null,
  enumValues?: readonly T[],
): T[] | undefined => {
  if (!items?.length) return undefined;

  const parsed = items.filter(
    (item): item is T =>
      item !== null &&
      item !== "" &&
      (!enumValues || enumValues.includes(item as T)),
  );

  return parsed.length > 0 ? parsed : undefined;
};
